import React, {useContext} from "react";
import UserContext from '../../../../contexts/userContext';
import {
  Divider,
  Avatar,
  Row,
  Col,
} from "antd";
import IntlMessages from "../../lang/IntlMessages";
import { FiLogOut } from "react-icons/fi";
import AuthService from '../../../../service/auth.service';
import avatar from "../../../../assets/images/memoji/memoji-1.png";
import { Link } from "react-router-dom";

export default function MenuFooter(props) {
  const { userprofile } = useContext(UserContext);
  const logOut = () => {
		AuthService.logout()
		window.location.reload()
	};

  return (
    props.collapsed === false ? (
      <Row
        className="hp-sidebar-footer hp-pb-24 hp-px-24 hp-bg-color-dark-100"
        align="middle"
        justify="space-between"
      >
        <Divider className="hp-border-color-black-20 hp-border-color-dark-70 hp-mt-0" />

        <Col>
          <Row align="middle">
            <Avatar size={36} src={avatar} className="hp-mr-8" />

            <div>
              <span className="hp-d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body">
                {userprofile?.name}
             </span>
             <Link
                to="/pages/profile/password-change"
                className="hp-badge-text hp-text-color-dark-30 hp-font-weight-400"
                onClick={props.onClose}
              >
                <IntlMessages id="sidebar-view-password" />
              </Link>
            </div>
          </Row>
        </Col>

        <Col>
            <Link to="#" onClick={logOut}>
              <FiLogOut
                className="remix-icon hp-text-color-black-100 hp-text-color-dark-0"
                size={24}
              />
            </Link>
        </Col>
      </Row>
    ) : (
      <Row
        className="hp-sidebar-footer hp-pt-16 hp-mb-16 hp-bg-color-dark-100"
        align="middle"
        justify="center"
      >
        <Col>
            <Avatar size={36} src={avatar} />
        </Col>
      </Row>
    )
  );
};